import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import SocialIcons from "@/components/SocialIcons";

export default function Footer() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [s, setS] = useState({});

  useEffect(() => {
    api.get("/settings").then(({ data }) => setS(data)).catch(() => {});
  }, []);

  const subscribe = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/newsletter", { email, source: "footer" });
      toast.success("You're one of the ONE LOOK girls now ♡");
      setEmail("");
    } catch { toast.error("Please try again"); }
    setLoading(false);
  };

  return (
    <footer data-testid="site-footer" className="relative z-10 mt-24 border-t" style={{ borderColor: "#EBE5ED", background: "#FDFBF7" }}>
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-16 grid grid-cols-2 md:grid-cols-5 gap-10">
        <div className="col-span-2">
          <div className="font-serif-display text-[22px] tracking-brand">ONE LOOK</div>
          <div className="italic text-[13px] mt-2 text-[#C3B1C5]">one look, effortlessly you.</div>
          <p className="mt-6 text-[13px] leading-relaxed max-w-sm text-[#4A464A]/80">
            A Singapore fashion label curating complete, ready-to-wear looks. We did the matching for you.
          </p>
          <form onSubmit={subscribe} className="mt-6 flex items-center border-b" style={{ borderColor: "#C3B1C5" }}>
            <input data-testid="footer-newsletter-email" type="email" required value={email} onChange={e => setEmail(e.target.value)}
                   placeholder="Your email" className="flex-1 bg-transparent py-2 text-[13px] outline-none placeholder:text-[#4A464A]/40" />
            <button data-testid="footer-newsletter-submit" type="submit" disabled={loading} className="text-[11px] uppercase tracking-editorial pl-3">
              {loading ? "…" : "Join"}
            </button>
          </form>
          <div className="mt-6">
            <SocialIcons settings={s} variant="footer" testPrefix="footer-social" />
          </div>
        </div>
        {[
          { title: "Shop", links: [["Shop The Look", "/looks"], ["New In", "/new-in"], ["Work", "/mood/work"], ["Date", "/mood/date"]] },
          { title: "Help", links: [["FAQ", "/faq"], ["Shipping", "/shipping"], ["Returns", "/returns"], ["Size Guide", "/size-guide"]] },
          { title: "About", links: [["Our Story", "/about"], ["Contact", "/contact"]] },
          { title: "Legal", links: [["Privacy Policy", "/privacy"], ["Terms of Sale", "/terms"]] },
        ].map(col => (
          <div key={col.title}>
            <div className="text-[11px] uppercase tracking-editorial mb-4 text-[#4A464A]">{col.title}</div>
            <ul className="space-y-3 text-[13px]">
              {col.links.map(([label, to]) => <li key={label}><Link to={to} className="hover:text-[#C3B1C5]">{label}</Link></li>)}
            </ul>
          </div>
        ))}
      </div>
      <div className="border-t py-6 text-center text-[11px] tracking-editorial uppercase text-[#4A464A]/60" style={{ borderColor: "#EBE5ED" }}>
        © {new Date().getFullYear()} ONE LOOK Singapore
      </div>
    </footer>
  );
}
